import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { updateState } from './requests'
export type ShowFromToChangePayload = {
  itemFrom: number
  itemTo: number
  groupFrom: number
  groupTo: number
}

/**
 * Change from-to range
 */
export const showFromToChange = (state: InsightsDashboardPoolState, payload: ShowFromToChangePayload) =>
  updateState(state, payload)
